export default __webpack_public_path__ + "static/media/dev.4b6d2853.svg";